import { render, staticRenderFns } from "./TipoEfecto.vue?vue&type=template&id=0309d802&scoped=true"
import script from "./TipoEfecto.vue?vue&type=script&lang=js"
export * from "./TipoEfecto.vue?vue&type=script&lang=js"
import style0 from "./TipoEfecto.vue?vue&type=style&index=0&id=0309d802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309d802",
  null
  
)

export default component.exports